import { useTheme } from '../contexts/ThemeContext';

const useThemedStyles = (styles: any, onlyLightTheme?: boolean) => {
    const { theme } = useTheme();
    return styles(onlyLightTheme ? 'light' : theme);
};

export default useThemedStyles;
